// src/components/home/UserHeader.jsx
import React from 'react';
import AnimatedNumber from '../ui/AnimatedNumber';

function UserHeader({ stats, navigate }) {
  if (!stats) return null;

  return (
    <div className="user-header-container">
      <div className="userheader-card user-header-card mb-4">
        {/* Overlay scuro per leggibilità */}
        <div className="d-flex align-items-center justify-content-between user-header-unified">
                  <div
          className="user-header-block p-1  text-center position-relative"
          onClick={() => navigate(`/ranking`)}
          onKeyDown={e => e.key === 'Enter' && navigate(`/ranking`)}
          role="button"
          tabIndex={0}
        >
          <div className="stat-icon-wrapper mb-2">
            <div className="stat-icon-circle bg-brand-secondary">
              <i className="bi bi-trophy-fill text-brand-primary"></i>
            </div>
          </div>
          <div className="stat-value fw-bold fs-4 text-white text-center mb-1">
            <AnimatedNumber value={stats.rosterPosition} fallback="-" />
            <span className="fs-6 opacity-75">°</span>
          </div>
          <div className="stat-label text-light opacity-75 small mb-1">
            Classifica
          </div>
        </div>
 
        <div className="user-header-separator mx-0"></div>

         <div
            className="user-header-block p-1 text-center position-relative"
            onClick={() => navigate(`/profile`)}
            onKeyDown={e => e.key === 'Enter' && navigate(`/profile`)}
            role="button"
            tabIndex={0}
          >
          <div className="stat-icon-wrapper mb-2">
            <div className="stat-icon-circle bg-circle-accent">
              <i className="bi bi-graph-up text-white"></i>
            </div>
          </div>
          <div className="stat-value fw-bold fs-4 text-white text-center mb-1">
            <AnimatedNumber value={stats.totalPoints || 0} />
          </div>
          <div className="stat-label text-light opacity-75 small mb-1">
            Punti
          </div>
          {stats.pointsChange > 0 && (
            <div className="stat-change rounded-pill px-2 py-1 d-inline-block">
              <small className="fw-semibold">
                <i className="bi bi-arrow-up me-1"></i>
                <AnimatedNumber value={stats.pointsChange} prefix="+" />
              </small>
            </div>
          )}
          {stats.pointsChange < 0 && (
            <div className="stat-change rounded-pill px-2 py-1 d-inline-block">
              <small className="fw-semibold">
                <i className="bi bi-arrow-down me-1"></i>
                <AnimatedNumber value={stats.pointsChange} />
              </small>
            </div>
          )}
        </div>


      </div>
      </div>
    </div>
  );
}

export default UserHeader;
